import { createAsyncThunk,createSlice } from "@reduxjs/toolkit";
import Admin from "apis/Admin";

const loginType = localStorage.getItem("loginType");
export const podcastRequest = createAsyncThunk("podcastList",async([start,limit])=>{
  const response = await Admin.get(parseInt(loginType) === 1 ? `podcast/all/${start}/${limit}`:`podcast/partner/${start}/${limit}` );
  console.log(response,"podcast response")
  return response.data.data
});

export const deletePodcast = createAsyncThunk(
  "deletePodcast",
  async ([...data]) => {
    await Admin.delete("deleteUserPosts",{data: {posts: [...data]}});
    console.log("delete data")
    return data;
  }
)

const podcastSlice = createSlice({
  name:"podcast",
  initialState:{podcastArray:[],totalList:'',message:"",loading:false},
  reducers:{},
  extraReducers:{
    [podcastRequest.fulfilled]:(state,action) => {
      return { ...state, podcastArray:action.payload.podcasts, totalList: action.payload.totalPodcasts, message:action.payload.message, loading:false}
    },
    [podcastRequest.pending]:(state) => {
       return {...state,loading:true}
    },
    [podcastRequest.rejected]:(state,action) => {
      return {
        ...state,
        podcastArray:action.payload,
        message:"no data",
        loading:false
      }
    },
    [deletePodcast.fulfilled]: (state, action) => {
      console.log(action,"action")
      return {
        ...state,
        podcastArray: state.podcastArray.filter((data) => data._id !== action.payload[0]),
        loading: false
      };
    },
    [deletePodcast.pending]: (state) => {
      return {
        ...state,
        loading: true,
      };
    },
    [deletePodcast.rejected]: (state) => {
      return {
        ...state,
        loading: false,
        message: "News Deletion Failed"
      };
    },
  }
})

export default podcastSlice.reducer;